export const API_TOTAL_EARNING_SUCCESS = "API_TOTAL_EARNING_SUCCESS";
export const API_TOTAL_EARNING_FAIL = "API_TOTAL_EARNING_FAIL";
export const GET_TOTAL_EARNING = "GET_TOTAL_EARNING";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const EMPTY_TOTAL_EARNING = 'EMPTY_TOTAL_EARNING';
